//When adding new exports to this file, also add them to index.ts.
export {
  AnimationStyles,
  AnimationVariables,
  CommunicationColors,
  DefaultEffects,
  DefaultFontStyles,
  DefaultPalette,
  DefaultSpacing,
  Depths,
  FluentTheme,
  createFontStyles,
  createTheme,
  LocalizedFontFamilies,
  LocalizedFontNames,
  mergeThemes,
  MotionDurations,
  MotionTimings,
  MotionAnimations,
  NeutralColors,
  SharedColors,
  registerDefaultFontFaces,
  ComponentStyles,
  ComponentsStyles,
  IAnimationStyles,
  IAnimationVariables,
  IEffects,
  IFontStyles,
  IPalette,
  IPartialTheme,
  IScheme,
  ISchemeNames,
  ISemanticColors,
  ISemanticTextColors,
  ISpacing,
  ITheme,
  PartialTheme,
  Theme,
} from '@fluentui/theme';
export * from '@fluentui/react-theme-provider';
//When adding new exports to this file, also add them to index.ts.
